export default "__VITE_ASSET__CKBiRCoy__"